"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Typeahead = _interopRequireDefault(require("../core/Typeahead"));

var _ClearButton = _interopRequireDefault(require("./ClearButton.react"));

var _Loader = _interopRequireDefault(require("./Loader.react"));

var _TypeaheadInputMulti = _interopRequireDefault(require("./TypeaheadInputMulti.react"));

var _TypeaheadInputSingle = _interopRequireDefault(require("./TypeaheadInputSingle.react"));

var _TypeaheadMenu = _interopRequireDefault(require("./TypeaheadMenu.react"));

var _utils = require("../utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var propTypes = {
  /**
   * Specifies the size of the input.
   */
  bsSize: _propTypes.default.oneOf(['large', 'lg', 'small', 'sm']),

  /**
   * Displays a button to clear the input when there are selections.
   */
  clearButton: _propTypes.default.bool,

  /**
   * Bootstrap 4 only. Adds the `is-invalid` classname to the `form-control`.
   */
  isInvalid: _propTypes.default.bool,

  /**
   * Indicate whether an asynchronous data fetch is happening.
   */
  isLoading: _propTypes.default.bool,

  /**
   * Bootstrap 4 only. Adds the `is-valid` classname to the `form-control`.
   */
  isValid: _propTypes.default.bool,

  /**
   * Callback for custom input rendering.
   */
  renderInput: _propTypes.default.func,

  /**
   * Callback for custom menu rendering.
   */
  renderMenu: _propTypes.default.func
};
var defaultProps = {
  clearButton: false,
  isInvalid: false,
  isLoading: false,
  isValid: false,
  renderMenu: function renderMenu(results, menuProps) {
    return (// TODO: Merged props not registering correctly.
      // $FlowFixMe
      _react.default.createElement(_TypeaheadMenu.default, _extends({}, menuProps, {
        options: results
      }))
    );
  }
};

var TypeaheadComponent =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TypeaheadComponent, _React$Component);

  function TypeaheadComponent() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TypeaheadComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TypeaheadComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "_instance", null);

    _defineProperty(_assertThisInitialized(_this), "getInstance", function () {
      return _this._instance;
    });

    _defineProperty(_assertThisInitialized(_this), "_renderInput", function (inputProps) {
      var _this$props = _this.props,
          bsSize = _this$props.bsSize,
          isInvalid = _this$props.isInvalid,
          isValid = _this$props.isValid,
          multiple = _this$props.multiple,
          renderInput = _this$props.renderInput,
          renderToken = _this$props.renderToken;

      if ((0, _isFunction.default)(renderInput)) {
        return renderInput(inputProps);
      }

      var props = _objectSpread({}, inputProps, {
        bsSize: bsSize,
        isInvalid: isInvalid,
        isValid: isValid
      });

      return multiple ? _react.default.createElement(_TypeaheadInputMulti.default, _extends({}, props, {
        renderToken: renderToken
      })) : _react.default.createElement(_TypeaheadInputSingle.default, props);
    });

    _defineProperty(_assertThisInitialized(_this), "_renderMenu", function (results, menuProps) {
      var _this$props2 = _this.props,
          emptyLabel = _this$props2.emptyLabel,
          maxHeight = _this$props2.maxHeight,
          newSelectionPrefix = _this$props2.newSelectionPrefix,
          renderMenu = _this$props2.renderMenu,
          renderMenuItemChildren = _this$props2.renderMenuItemChildren;
      return renderMenu(results, _objectSpread({}, menuProps, {
        emptyLabel: emptyLabel,
        maxHeight: maxHeight,
        newSelectionPrefix: newSelectionPrefix,
        renderMenuItemChildren: renderMenuItemChildren
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "_renderAux", function (props) {
      var bsSize = props.bsSize,
          clearButton = props.clearButton,
          disabled = props.disabled,
          isLoading = props.isLoading,
          onClear = props.onClear,
          selected = props.selected;
      var content;

      if (isLoading) {
        content = _react.default.createElement(_Loader.default, {
          bsSize: bsSize
        });
      } else if (clearButton && !disabled && selected.length) {
        content = _react.default.createElement(_ClearButton.default, {
          bsSize: bsSize,
          onClick: onClear,
          onFocus: function onFocus(e) {
            // Prevent the main input from auto-focusing again.
            e.stopPropagation();
          },
          onMouseDown: _utils.preventInputBlur
        });
      }

      return content ? _react.default.createElement("div", {
        className: (0, _classnames.default)('rbt-aux', {
          'rbt-aux-lg': bsSize === 'large' || bsSize === 'lg'
        })
      }, content) : null;
    });

    return _this;
  }

  _createClass(TypeaheadComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className;
      return _react.default.createElement(_Typeahead.default, _extends({}, this.props, {
        ref: function ref(instance) {
          return _this2._instance = instance;
        }
      }), function (props) {
        var auxContent = _this2._renderAux(props);

        return _react.default.createElement("div", {
          className: (0, _classnames.default)('rbt', 'clearfix', 'open', {
            'has-aux': !!auxContent
          }, className),
          style: {
            position: 'relative'
          },
          tabIndex: -1
        }, _react.default.createElement(_Typeahead.default.Input, null, _this2._renderInput), _react.default.createElement(_Typeahead.default.Menu, null, _this2._renderMenu), auxContent, (0, _isFunction.default)(children) ? children(props) : children);
      });
    }
  }]);

  return TypeaheadComponent;
}(_react.default.Component);

_defineProperty(TypeaheadComponent, "propTypes", propTypes);

_defineProperty(TypeaheadComponent, "defaultProps", defaultProps);

var _default = TypeaheadComponent;
exports.default = _default;